// Import .less entry point
import '../assets/private/stylesheets/app.less';
import './commons/styles/style';

/** specific country repository imports */
import '@/_override/shared/shared-country.less';
/** end of specific country repository imports */

import 'jquery';

// ES6 polyfills
import 'core-js/stable';

// - Intersection Observer polyfill (for lazyloading content)
import 'intersection-observer';

// Global Var polyfill (maybe only for the recaptcha)
window.decathlon = {};

/* eslint-disable-next-line no-console */
window.logError = (...args) => console.error(...args);



// WEBPACK FOOTER //
// ./src/dkt-header.js